import { type TranslationTree } from '@/i18n/types';

export const messages = {
  contactName: 'Nome do contato',
  contactEmail: 'E-mail de contato',
  contactPhone: 'Telefone ou WhatsApp',
  contactPhonePlaceholder: '(83) 99999-0000',
  city: 'Cidade',
  cityPlaceholder: 'João Pessoa',
  state: 'UF',
  noState: '—',
  website: 'Site',
  instagram: 'Instagram',
  optional: 'Opcional',
} satisfies TranslationTree;
